module.exports = __webpack_public_path__ + "static/media/recipeDetail.c6112e50.gif";